var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrailerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.918 6.33594H2.91797V14.5599H22.918V6.33594Z",
    stroke: "#121316",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.29775 19.3728C8.21188 19.3728 8.95292 18.6318 8.95292 17.7177C8.95292 16.8035 8.21188 16.0625 7.29775 16.0625C6.38362 16.0625 5.64258 16.8035 5.64258 17.7177C5.64258 18.6318 6.38362 19.3728 7.29775 19.3728Z",
    stroke: "#121316",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3056 19.3728C13.2197 19.3728 13.9607 18.6318 13.9607 17.7177C13.9607 16.8035 13.2197 16.0625 12.3056 16.0625C11.3914 16.0625 10.6504 16.8035 10.6504 17.7177C10.6504 18.6318 11.3914 19.3728 12.3056 19.3728Z",
    stroke: "#121316",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5391 16.2858V14.2656",
    stroke: "#121316",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.98563 14.6094L3.60938 16.7729",
    stroke: "#121316",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6797 14.6094L16.059 16.6783",
    stroke: "#121316",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrailerIcon);
export default __webpack_public_path__ + "static/media/trailer-icon.7f162b178ed4ed3a59a90f275c142d59.svg";
export { ForwardRef as ReactComponent };